import { TWITTER_LOGIN_INIT } from '../actionTypes/login';
import {
  FETCH_INIT_SUCCESS,
  FETCH_INIT_FAIL,
  FETCH_POI_BANK_INIT_SUCCESS,
  FETCH_POI_BANK_INIT_FAIL
} from '../actions/action_types';
import initAdapter from '../utilities/initAdapter';

export default (
  state = {
    webToken: '',
    error: null,
    // poiBankToken: '',
    poiBankInitError: null,
    loginMethod: [],
    loginMethodMaintenance: [],
    twitter: null
  },
  action
) => {
  switch (action.type) {
    case FETCH_INIT_SUCCESS:
      return handleInitSuccess(state, action.payload.results);
    case FETCH_INIT_FAIL:
      // console.log('init fail');
      return { error: action.payload };
    case FETCH_POI_BANK_INIT_SUCCESS:
      return handlePoiBankInitSuccess(state, action.payload.results);
    case FETCH_POI_BANK_INIT_FAIL:
      return { poiBankInitError: action.payload };
    case TWITTER_LOGIN_INIT.SUCCESS: {
      const initInfo = action.payload.reduce((accu, current) => {
        const { key, value } = current;
        accu[key] = value;
        return accu;
      }, {});

      localStorage.setItem(
        'twitterLoginKey',
        JSON.stringify(initInfo?.LoginKey)
      );
      return {
        ...state,
        twitter: initInfo
      };
    }
    default:
      return state;
  }
};

const handleInitSuccess = (state, results) => {
  const initResults = { ...state };
  for (let i = 0; i < results.length; i++) {
    const obj = results[i];
    if (obj.key === 'Ads') {
      initResults.ads = obj.value;
    }
    if (obj.key === 'Target') {
      initResults.target = obj.value;
    }
    if (obj.key === 'DisplayExperiences') {
      initResults.displayExperiences = obj.value;
    }
    if (obj.key === 'Area') {
      initResults.area = obj.value;
      localStorage.setItem('area', obj.value);
    }
    if (obj.key === 'LoginMethod') {
      initResults.loginMethod = [...obj.value];
    }
    if (obj.key === 'LoginMethodMaintenance') {
      initResults.loginMethodMaintenance = [...obj.value];
    }
  }
  if (initAdapter.webToken && !localStorage.getItem('webToken')) {
    initResults.webToken = initAdapter.webToken;
    localStorage.setItem('webToken', JSON.stringify(initAdapter.webToken));
  }
  console.log('handleInitSuccess', initResults);

  return initResults;
};

// salt
export const desalt = (type, string) => {
  switch (type) {
    case 0: // extract last two characters and add to front
      return string.slice(2, string.length);
    case 1: // extract first three characters and add to the end of string
      return string.slice(0, string.length - 3);
    case 2: // duplicate last character
      return string.slice(0, string.length - 1);
    default:
      return string;
  }
};

const handlePoiBankInitSuccess = (state, results) => {
  const initResults = { ...state };
  localStorage.setItem('poiBankToken', results.access_token || results?.token);
  // initResults.poiBankToken = results.access_token;
  // console.log('poi bank init results = ', initResults);
  return initResults;
};
